export default __webpack_public_path__ + "0c8750778ebdcabe1873122252124085.png";